<template>
  <v-divider class="mb-1" />
</template>

<script>
export default {
  name: 'MenuItemDivider'
};
</script>
